import type React from 'react'

export type FooterNavigationSemanticName = 'root' | 'child'

export interface FooterNavigationModuleIds {
  marketingConversion?: string
  mainServices?: string
  footerBrand?: string
}

export interface FooterNavigationProps extends React.HTMLAttributes<HTMLElement> {
  data: any
  currentCountry?: any
  subscribeLoading?: boolean
  event?: {
    signup?: (_params: any) => void
    download?: () => void
    country?: () => void
    cookiesSet?: () => void
  }
  classNames?: Partial<Record<FooterNavigationSemanticName, string>>
  /** 各模块的 id，用于 URL #锚点定位 */
  moduleIds?: FooterNavigationModuleIds
}

export enum FooterNavigationBlockType {
  Signup = 'ipc-footer-signup',
  Main = 'ipc-footer-main',
  Brand = 'ipc-footer-brand',
}
